var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "742", height: "205", viewBox: "0 0 742 205", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "toothbrush-svgrepo-com"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { d: "M16.24 89.998l-.001 91.96a22.987 22.987 0 0 0 22.991 22.99h137.941a22.916 22.916 0 0 0 16.256-6.732 22.915 22.915 0 0 0 6.732-16.257l.005-91.962c0-6.099-2.42-11.947-6.733-16.257a22.984 22.984 0 0 0-16.256-6.734l-137.945.002c-12.696.001-22.99 10.293-22.99 22.99z", fill: "#DBDDF6" }),
      React.createElement("path", { d: "M16.24 89.998l-.002 91.961a22.987 22.987 0 0 0 22.992 22.99h68.97V67.006l-68.97.002c-12.696.001-22.99 10.293-22.99 22.99z", fill: "#C4C8F2" }),
      React.createElement("path", { d: "M31.79 158.968C14.737 158.97.91 169.262.916 181.961c.002 12.699 13.825 22.99 30.877 22.99h308.77c1.7 0 3.4-.106 5.077-.312l120.988-15.017h244.456c8.525.002 16.243-2.572 21.832-6.733 5.587-4.16 9.045-9.906 9.045-16.255-.001-12.699-13.825-22.993-30.876-22.992H464.072c-1.701 0-3.4.105-5.078.312L338.005 158.97H31.79z", fill: "#CE8BD4" }),
      React.createElement("path", { d: "M31.79 158.968C14.737 158.97.91 169.262.914 181.96c.003 12.7 13.825 22.991 30.878 22.991H340.56c1.7 0 3.4-.107 5.077-.312l25.798-3.201V154.82l-33.43 4.148H31.79z", fill: "#BF6AC8" }),
      React.createElement("path", { d: "M4.337 36.001c.4 22.96 19.336 41.245 42.295 40.844l120.97-2.112c15.546-.27 29.236 8.034 36.587 20.55 11.42-7.584 18.853-20.649 18.597-35.373-.4-22.96-19.336-41.245-42.295-40.844-23.258.404-97.712 1.706-120.97 2.111-15.546.272-29.236-8.033-36.587-20.55C11.512 8.213 4.08 21.277 4.337 36.002z", fill: "#51C6E5" })
    )
  );
});